Shopify.queryParams = {};
if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
        var keyValue = params[i].split('=');

        if (keyValue.length) {
            Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
    }
}
$('#js-collection-sort-by').on('change',function (e){
    console.log("test")
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
})


/* top filter*/

// $(document).on('click','.select2-apply button',function (){
//     let select_wraper_id = this.closest('.select2-results').getElementsByClassName('select2-results__options')[0].id;
//     let select = document.querySelector(`[aria-owns="${select_wraper_id}"]`).closest('.sort-block').querySelector('select');
//     let select_name = select.getAttribute('data-filter-name');
//     let selected_option = [];
//     for(option of select.options ){
//         if(option.selected){
//             selected_option.push(option.getAttribute('value'));
//         }
//     }
//     let form_chexbox = document.querySelector('.js-collection-filter-form').querySelectorAll(`[data-form-filter-name="${select_name}"] input[type="checkbox"]`)
//     form_chexbox.forEach(function (element){
//         if(selected_option != null && selected_option.includes(element.value)){
//             element.checked=true;
//
//         }else {
//             element.checked=false;
//         }
//     });
//
//     document.getElementsByClassName('js-collection-filter-form')[0].submit();
//
// })

$('.js-sort-select-modal').on('change',function (){
    window.location.pathname=this.selectedOptions[0].dataset.url
})
$('.js-filter-checkbox').on('click',function (){
    window.location=$(this).closest('.checkbox').find($('.link a'))[0].href;
})
$('.js-filter-remove').on('click',function (e){
    e.preventDefault();
    window.location=$(this).closest('.filter-selected__item').find($('.link a'))[0].href;
})